import type { FaireProductEntity } from "../../entity_types/product";

export const p_k4tx6kxgyc: FaireProductEntity = {
  token: "p_k4tx6kxgyc",
  type: "product",
  name: "All You Need Is Love Women's Novelty Crew Socks",
  brandToken: "b_6nu7ayhqaw",
  brandName: "Fabdaz",
  imageUrl:
    "https://cdn.faire.com/fastly/9f0359419641bd0bf143d393d7dcc83b6437959d9596370a3da85b357a778d9b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/902901d0b8d0733194e32ebc53a1d07f759e82860a02931acfbe54ecae466116.jpeg",
    "https://cdn.faire.com/fastly/febab3af30bb89f381222a3c01f6a0c09b1c171920a8aea4f86c5ea4e71b3a8c.jpeg",
    "https://cdn.faire.com/fastly/3a9179fd31e14098a1e983c06b8400708459adf4cff766f87ada4b894e4a5f56.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "All You Need Is Love Women's Novelty Crew Socks\nStylish and comfortable!\nFits ladies' shoe size 5 to 10.\n80% Cotton, 15% Nylon, 5% Spandex.\nEasy Care - Machine Wash.\nItem # SK0057\nPacked on card peg hook ready, UPC coded.\nDesigned in Chattanooga, TN by our in-house artist Jennifer.",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:36.993Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
